import { preformsEndpoints } from "./preform.api"

export const {
  useGetGenesisPreformStoreQuery,
  useGetBoughtGenesisPreformsLeadersQuery,
  useBuyGenesisPreformMutation,
  useGetPreformsInventoryQuery,
  useUnpackPreformMutation,
  endpoints: {
    getGenesisPreformStore,
    getBoughtGenesisPreformsLeaders,
    getPreformsInventory,
    buyGenesisPreform,
    unpackPreform
  }
} = preformsEndpoints
